import React from 'react';
import { motion } from 'framer-motion';
export function CostComparison() {
  const rows = [{
    sin: 'Enseñás sin ejemplos argentinos',
    costo: 'Alumnos desconectados que no entienden por qué Argentina importa en el mundo nuclear'
  }, {
    sin: 'Sin banco de actividades contextualizadas',
    costo: 'Horas semanales perdidas armando material de cero sin contexto del CAREM-25 ni Atucha'
  }, {
    sin: 'Sin casos de estudio equilibrados',
    costo: 'Enseñás Chernóbil generando miedo en lugar de pensamiento crítico'
  }, {
    sin: 'Sin banco de evaluaciones nucleares',
    costo: 'Evaluaciones repetidas que no miden lo que realmente importa en física nuclear'
  }, {
    sin: 'Sin infografías del reactor al enchufe',
    costo: 'Esquemas dibujados a mano que no transmiten la escala real ni el flujo de energía de Atucha'
  }, {
    sin: 'Sin conexión con la actualidad nuclear',
    costo: 'Alumnos que no saben que el CAREM-25 es histórico para el mundo, no solo para Argentina'
  }, {
    sin: 'Sin guía didáctica para temas difíciles',
    costo: 'Seguís generando el mito de que los reactores pueden explotar como bombas sin herramientas para corregirlo'
  }, {
    sin: 'Sin material imprimible optimizado',
    costo: 'Horas de diseño y edición que podrían dedicarse a enseñar'
  }];
  return <section className="py-20 bg-surface text-white" data-id="element-46">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="md:text-4xl font-extrabold mb-4 text-[20px]" data-id="element-49">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
        </div>

        <div className="overflow-x-auto pb-4 mb-12" data-id="element-50">
          <div className="min-w-[600px]" data-id="element-51">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-52">
              <div className="font-bold text-muted uppercase text-sm tracking-wider" data-id="element-53">
                ❌ Sin el Megapack
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider" data-id="element-54">
                💸 Lo que realmente perdés
              </div>
            </div>

            <div className="space-y-2" data-id="element-55">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 bg-base/50 rounded-xl p-4 items-center border border-surface/50" data-id="element-56">
                  <div className="text-muted font-medium" data-id="element-57">{row.sin}</div>
                  <div className="text-red-300 font-medium" data-id="element-58">{row.costo}</div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-muted/70 mt-4 md:hidden" data-id="element-59">
            ← Scroll to see full table →
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-base rounded-2xl p-8 md:p-12 shadow-2xl border border-surface" data-id="element-60">
          <p className="md:text-2xl font-medium text-electric mb-4 text-[18px]" data-id="element-61">
            "La próxima vez que un alumno pregunte para qué sirve estudiar
            energía nuclear, podés mostrarle que Argentina tiene reactores
            nucleares desde antes de que él naciera, que un reactor argentino
            construido en Bariloche genera los radioisótopos que diagnostican el
            cáncer en ocho países latinoamericanos cada semana, y que el primer
            reactor modular pequeño del mundo se está construyendo a 115 km de
            Buenos Aires. O podés seguir explicando sin ese contexto."
          </p>
          <p className="md:text-4xl font-black text-white text-[20px]" data-id="element-62">🇦🇷☢️</p>
        </motion.div>
      </div>
    </section>;
}